import { JsonApiRequestError } from '@farfetched/core';
import { Store } from 'effector';
import { createShiftRegistryQuery, ShiftListItem, ShiftRegistryFilters } from 'shared/api';
import {
	RegistryModel,
	DateFilterModel,
	createRegistryModel,
	getToday,
	createDateFilterModel,
} from 'shared/lib';

export type ShiftRegistryTotal = {
	deposits: number;
	withdrawals: number;
	income: number;
	currency: string;
};

export type ShiftRegistryModel = {
	registryModel: RegistryModel<ShiftListItem, ShiftRegistryFilters, JsonApiRequestError>;
	dateFilterModel: DateFilterModel;
	$total: Store<ShiftRegistryTotal | null>;
};

export const createShiftRegistryModel = (): ShiftRegistryModel => {
	const query = createShiftRegistryQuery();

	const [todayDate, currentTimeZone] = getToday();

	const registryModel = createRegistryModel({
		query,
		filters: {
			dateFrom: todayDate,
			dateTo: todayDate,
			timeZone: currentTimeZone,
			personal: false,
		},
	});

	const dateFilterModel = createDateFilterModel({
		fromChange: registryModel.filters.dateFrom.setValue,
		toChange: registryModel.filters.dateTo.setValue,
		reset: registryModel.clearFilters,
	});

	const $total = query.$data.map((data) => {
		if (!data) return null;

		return data.rows.reduce(
			(prev: ShiftRegistryTotal, row) => ({
				currency: row.currency,
				deposits: prev.deposits + row.deposits,
				withdrawals: prev.withdrawals + row.withdrawals,
				income: prev.income + row.income,
			}),
			{
				currency: '',
				deposits: 0,
				income: 0,
				withdrawals: 0,
			} as ShiftRegistryTotal,
		);
	});

	return {
		registryModel,
		dateFilterModel,
		$total,
	};
};
